import React from 'react';
import HeaderTitle from 'header/components/title';

const RegistrationHeaderTitle = () => (<HeaderTitle title="Join crowdspring" />);

export default RegistrationHeaderTitle;



// WEBPACK FOOTER //
// ./registration/common/components/header.jsx